<template lang="pug">
#flex
  .editor
    //- span SCSS
    vue-markdown(:source="contenthtml",ref="markd")
  //- editor(ref='css', v-model='contentcss', @init='editorInit', lang='scss', theme='dracula', width='100%', height='100%')
  //- .editor-html
  //-   span HTML
  //-   editor(ref='html', v-model='contenthtml', lang='html', theme='dracula', width='100%', height='100%')
  .content
    .item(:class="{'selected': selected=='flex'}",@click="selectItem('flex')")
      .title
        | Flex No-Wrap
      .content
        flex-01
    .item(:class="{'selected': selected=='flex02'}",@click="selectItem('flex02')")
      .title
        | Flex Wrap
      .content
        flex-02
</template>
<script>

var VueMarkdown = require('vue-markdown');
import Flex01 from './flex/flex-01';
import Flex02 from './flex/flex-02';

export default {
  components: {
        'vue-markdown': require('vue-markdown').default,
        'flex-01': Flex01,
        'flex-02': Flex02,
        // editor: require('vue2-ace-editor'),
    },
  data() {
    return {
    contentcss: '',
    contenthtml: '',
    selected: 'flex',
    options: {
      'ReadOnly': "true"
    }
    }
  },

  computed: {
  },
  mounted() {
    this.selectItem('flex');
  },

  methods: {
    selectItem(name) {
      this.selected = name;
      // this.contentcss = colors_css[name];
      this.contenthtml = '';
      this.readText(name);
    },

   async readText(name) {
     var name =  'flex/' + name + '.md';
     console.log(name)
      this.contenthtml = await this.$get(name);
      console.log(this.contenthtml)
      // Prism.highlightAll();
      this.$higlight_all(this);
    }
  }
}
</script>



<style lang="scss">



$color-red: #F44336;
$color-pink: #E91E63; 
$color-purple: #673AB7;

.block {
 width: 50px;
 height: 50px;
 display: inline-block;
 background: white;
 margin: 0;
}

#flex {
  overflow: auto;
  display: grid;
  height: 100%;
  grid-template-areas: "cnt editor"
                       "cnt editor";


  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;


  .content {
    overflow-x: none;
    overflow-y: auto;
    grid-area: cnt;
    overflow: auto;

    // width: 100%;
    border-right: 1px dashed  ;

    .selected {
       background-color: rgba($color-purple,0.3);
    }
    .item {
      height: inherit;
          display: flex;
    flex-wrap: wrap;

      cursor: pointer;
      border-bottom: 1px solid rgba(255,255,255,0.1);

      &:hover {
        background-color: rgba($color-purple,0.2);

        .title {
          color: #42b983;
        }
        
      }

      >.content {
        padding: 15px;
      }

      >.title {
        height: 2rem;
        padding-top: 15px;
        font-size: 16px;
        text-align: left;
        padding-left: 15px;

      }
    }
  } 


  .editor {
    overflow: auto;
    grid-area: editor;
    padding: 0;
    position: relative;
    text-align: left;
    padding: 10px;
    margin: 0;

    // >span {
    //   position: absolute ;
    //   color: white;
    //   z-index: 50;
    //   right: 30px;
    //   top : 4px;
    // }
  }

 

}

</style>
